import React, { useState } from "react";
import { Share, Check } from "@phosphor-icons/react";
import { toast } from "sonner";

/**
 * Copies a public share URL to the clipboard. Used for both the public product
 * spec sheet and the public order tracking link. Share icon only (no WhatsApp).
 */
export default function ShareLinkButton({
  url,
  idleLabel = "Share",
  copiedLabel = "Link copied",
  toastLabel = "Public link copied",
  testId,
  className = "",
}) {
  const [copied, setCopied] = useState(false);

  const copy = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    try {
      await navigator.clipboard.writeText(url);
    } catch {
      const ta = document.createElement("textarea");
      ta.value = url;
      document.body.appendChild(ta);
      ta.select();
      document.execCommand("copy");
      document.body.removeChild(ta);
    }
    setCopied(true);
    toast.success(toastLabel);
    setTimeout(() => setCopied(false), 2500);
  };

  return (
    <button
      type="button"
      onClick={copy}
      title={url}
      data-testid={testId}
      className={`inline-flex items-center justify-center gap-1.5 border border-zinc-200 hover:border-[#0047AB] hover:text-[#0047AB] px-3 py-2 text-xs font-medium transition-colors ${className}`}
    >
      {copied ? <Check size={15} weight="bold" /> : <Share size={15} />}
      {copied ? copiedLabel : idleLabel}
    </button>
  );
}
